export const SegmentModel = {
  "name": "",
  "type": "DYNAMIC",
  "matchType": "OR",
  "segmentGroups": [
    {
      "matchType": "AND",
      "filters": [
        {
          "operator": "IS_PRESENT",
          "segmentProperty": {
            "name": null,
            "entityType": null,
            "subEntityType": null
          },
          "segmentValue": {
            "value": true,
            "type": null
          }
        }
      ]
    }
  ]
}

export const DefaultFilter = {
  "operator": "IS_PRESENT",
  "segmentProperty": {
    "name": null,
    "entityType": null,
    "subEntityType": null
  },
  "segmentValue": {
    "value": true,
    "type": null
  }
}

export const DefaultGroup = {
  "matchType": "AND",
  "filters": [
    {
      "operator": "IS_PRESENT",
      "segmentProperty": {
        "name": null,
        "entityType": null,
        "subEntityType": null
      },
      "segmentValue": {
        "value": true,
        "type": null
      }
    }
  ]
}